<script setup lang="ts">
import { DialogController } from "~/components/Base/Dialog/dialog-controller";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "~/components/ui/dialog";

const props = defineProps({
  controller: {
    type: Object as PropType<DialogController>,
    required: false,
  },
  showHeader: {
    type: Boolean,
    default: true,
  },

  // whether the user can click outside to close the dialog to close it
  allowClose: {
    type: Boolean,
    default: true,
  },
});

const isOpen = ref(false);

const openDialog = () => {
  isOpen.value = true;
};

const closeDialog = () => {
  isOpen.value = false;
};

// Bind controller methods if provided
if (props.controller) {
  props.controller.open = openDialog;
  props.controller.close = closeDialog;
}

const onPointerDownOutside = (event: Event) => {
  if (props.allowClose != true) {
    event.preventDefault();
    return;
  }

  if ((event.target as HTMLElement).getAttribute("data-state") == undefined) {
    event.preventDefault();
    return;
  }
};
</script>

<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger>
      <slot name="trigger" />
    </DialogTrigger>
    <DialogContent
      @pointerDownOutside="onPointerDownOutside"
      :allowClose="allowClose"
    >
      <DialogHeader v-if="showHeader">
        <DialogTitle>
          <slot name="title" />
        </DialogTitle>
        <DialogDescription>
          <slot name="description" />
        </DialogDescription>
      </DialogHeader>
      <slot name="content" />
      <DialogFooter>
        <slot name="footer" />
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<style scoped></style>
